import { render, staticRenderFns } from "./RiskLevel.vue?vue&type=template&id=3b716210&scoped=true"
import script from "./RiskLevel.vue?vue&type=script&lang=js"
export * from "./RiskLevel.vue?vue&type=script&lang=js"
import style0 from "./RiskLevel.vue?vue&type=style&index=0&id=3b716210&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b716210",
  null
  
)

export default component.exports